import React, { useState, useEffect } from "react";

import prestataires from "../../datas/prestataires.json"; // mock JSON
function getDistance(lat1, lon1, lat2, lon2) {
    const toRad = x => (x * Math.PI) / 180;
    const R = 6371; // rayon de la Terre en km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
  
  
const SearchPrestataires = () => {
    const [filtered, setFiltered] = useState([]);
    const [secteur, setSecteur] = useState("");
    const [distance, setDistance] = useState(null);
  
    const secteurs = [...new Set(prestataires.map(p => p.secteur))];
    const userLat = 48.8566; // Position simulée (Paris)
    const userLon = 2.3522;
  
    useEffect(() => {
      const res = prestataires.filter(p => {
        const matchSecteur = secteur === "" || p.secteur === secteur;
        const matchDistance =
          distance == null || getDistance(userLat, userLon, p.lat, p.lon) <= distance;
          console.log(distance)
        return matchSecteur && matchDistance;
      });
      setFiltered(res);
    }, [secteur, distance]);
  
    return (
      <div className="container mt-4">
        <h2>Recherche de prestataires</h2>
  
        <div className="d-flex gap-3 mb-4">
          <select className="form-select" onChange={e => setSecteur(e.target.value)}>
            <option value="">Tous les secteurs</option>
            {secteurs.map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
  
          <select className="form-select" onChange={e => setDistance(Number(e.target.value))}>
            <option value="1000000">Toutes distances</option>
            <option value="10">Moins de 10 km</option>
            <option value="50">Moins de 50 km</option>
            <option value="100">Moins de 100 km</option>
          </select>
        </div>
  
        {filtered.length > 0 ? (
          <div className="list-group">
            {filtered.map(p => (
              <div key={p.id} className="list-group-item">
                <h5>{p.nom}</h5>
                <p>{p.adresse}</p>
                <p><strong>Secteur :</strong> {p.secteur}</p>
                <p>distance: {getDistance(userLat, userLon, p.lat, p.lon)}</p>
              </div>
            ))}
          </div>
        ) : (
          <p>Aucun prestataire trouvé.</p>
        )}
      </div>
    );
  }
  export default SearchPrestataires